import React from 'react';
import PropTypes from 'prop-types';
import { SFUpcomingAppt, SFNotification } from 'utils/types';
import css from './UpcomingView.css';
import Placeholder from 'serviceCatalog/home/connections/ConnectionsListPlaceholder';
import UpcomingList from './UpcomingList';

export default class UpcomingView extends React.Component {

  get content() {
    if ( this.props.hasFetched && this.props.upcomingEvents !== null ) {
      return (
        <UpcomingList
          upcomingEvents={this.props.upcomingEvents}
          timeZone={this.props.timeZone}
          getAppointments={this.props.getAppointments}
          notification={this.props.notification}
        />
      );
    }

    if ( !this.props.hasFetched ) {
      return (
        <div className={css['placeholder']}><Placeholder numberOfItems={1} numberOfLines={5} /></div>
      );
    }
  }

  render() {
    return (
      <div className={css['container']}>
        {this.content}
      </div>
    );
  }
}

UpcomingView.propTypes = {
  upcomingEvents: PropTypes.shape({
    appointments: PropTypes.arrayOf(PropTypes.shape(SFUpcomingAppt))
  }),
  notification: SFNotification.isRequired,
  timeZone: PropTypes.string,
  hasFetched: PropTypes.bool.isRequired,
  getAppointments: PropTypes.func.isRequired
};
